// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item__content button[data-v-4ba5c8a0] {\n  margin-bottom: 0 !important;\n}\n.el-form-item--small.el-form-item[data-v-4ba5c8a0] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
